import '@/assets/style/myshipment.scss';
import "@fontsource/source-sans-pro"

export default {
    install() {


    }
  };
  